import { defineStore } from "pinia";

import api from "@/api";
import { useUserStore } from "./user";

export const useUnitStore = defineStore("unit", {
  state: () => ({ 
    allDict: {},
    multiOrgAllDict: {}, // Make this a new state so it doesn't effect current state
    loading: false,
    dropdownOptions: [],
  }),
  actions: {
    async fetchAll() {
      try {
        this.loading = true;
        const userStore = useUserStore()
        const organization_id = userStore.activeOrganization ?? null
        const params = {}
        if(organization_id) {
          params.organization_id = organization_id
        }
        const res = await api.unit.fetchAll(params);
        this.allDict = res.data.reduce((dict, unit) => {
          dict[unit.unit_details.id] = { ...unit.unit_details, unit_users: unit.unit_users_ids };
          return dict;
        }, {});

        this.dropdownOptions = Object.values(this.allDict)
          .filter((unit) => unit.is_active)
          .map(({ id, store_name }) => {
            return { value: id, text: store_name || "N/A" };
          });

      } catch (error) {
        console.error(error.message);
      } finally {
        this.loading = false;
      }
    },
    // Method to add the units for an organization
    async insertToMultiOrgAllDict(orgId) {
      try {
        // this.loading = true;

        const userStore = useUserStore()
        const allowedOrgs = userStore.allowedOrganizations
        // console.log("allowedOrgs: ", allowedOrgs)
  
        if(!allowedOrgs.includes(orgId)) {
          throw new Error(`Cannot get units, no permissions to access this org: ${orgId}`)
        }

        const res = await api.unit.fetchAll({organization_id: orgId})
        
        // append to allDict
        res.data.forEach((unit)=>{
          this.multiOrgAllDict[unit.unit_details.id] = { ...unit.unit_details, unit_users: unit.unit_users_ids }
        })
      } catch(err) {
        console.error(err.message)
      } finally {
        // this.loading = false;
      }
    },

    clearMultiOrgAllDict() {
      this.multiOrgAllDict = {}
    }
  },
});
